import React, { useEffect, useMemo } from 'react';
import './userGroups.css';

import TableInput, { InputColumnConfig } from '../../../../components/common/table_input/tableInput';
import SQLTable, { TableColumnConfig, JsonColumnConfig } from '../../../../components/sql_table/tableMain';
import { getUniqueDropdownOptions } from '../../../../helper_functions';
import { useApiData } from '../../../../contexts/apiService';
import { useDataManager } from '../../../../contexts/dataManager';

const UserGroups = ({ 
}) => {

    const { apiData } = useApiData();
    const { requestTableData, hasTableData } = useDataManager();

    // Fetch required tables if not available
    useEffect(() => {
        if (!hasTableData('producer_groups')) requestTableData('producer_groups');
        if (!hasTableData('producer_definition')) requestTableData('producer_definition');
        if (!hasTableData('entity_definition')) requestTableData('entity_definition');
        if (!hasTableData('lease_coordinates')) requestTableData('lease_coordinates');
    }, []);

    // Get unique dropdown options for producer_id
    const producerOptions = (apiData?.producer_definition?.length ?? 0) > 0
        ? getUniqueDropdownOptions({
            tableData: apiData!.producer_definition,
            valueColumn: 'id',
            labelColumn: 'producer_name',
        }) : [];

    // Get unique dropdown options for lease_id
    const leaseOptions = (apiData?.lease_coordinates?.length ?? 0) > 0
        ? getUniqueDropdownOptions({
            tableData: apiData!.lease_coordinates,
            valueColumn: 'id',
            labelColumn: 'lease',
        }) : [];

    const inputCols: InputColumnConfig[] = [
        { colName: 'producer_id', colType: 'number', placeholder: 'Producer', required: true, inputType: 'dropdown', dropdownOptions: producerOptions },
        { colName: 'group_name', colType: 'text', placeholder: 'Group Name', required: true },
        { colName: 'display_name', colType: 'text', placeholder: 'Display Name', required: true },
        { colName: 'is_default', colType: 'boolean', placeholder: 'Is Default', required: true },
    ];

    const tableCols: TableColumnConfig[] = [
        { colName: 'id', colHeader: 'ID', colType: 'text' },
        { colName: 'producer_name', colHeader: 'Producer', colType: 'text' },
        { colName: 'group_name', colHeader: 'Group Name', colType: 'text', editable: true, inputType: 'dropdown', dropdownOptions: producerOptions },
        { colName: 'display_name', colHeader: 'Display Name', colType: 'text', editable: true },
        { colName: 'is_default', colHeader: 'Is Default', colType: 'boolean', editable: true  },
        { colName: 'lease_ids', colHeader: 'Leases', colType: 'json', jsonCols: ['lease_id'] },
    ];

    const jsonCols: JsonColumnConfig[] = [
        {
            pointsTo: 'lease_ids',
            fields: [
                {
                    colName: 'lease_id',
                    colType: 'number',
                    placeholder: 'Select Lease',
                    required: true,
                    inputType: 'dropdown',
                    dropdownOptions: leaseOptions
                },
            ],
            displayJsonCols: [
                { colName: 'lease_name', colHeader: 'Lease Name', colType: 'text' },
            ],
        },
    ];
    
    const tableData = useMemo(() => {
        const baseData = apiData?.producer_groups || [];
        return baseData;
    }, [apiData?.producer_groups]);

    return (
        <div className="userGroups-mainContainer">
            <TableInput
                tableName={'producer_groups'}
                inputColumnConfigs={inputCols}
            />
            <div className="userGroups-tableContainer">
                <SQLTable
                    tableName={'producer_groups'}
                    tableData={tableData}
                    idColumn={'id'}
                    columnConfigs={tableCols}
                    jsonColumnConfig={jsonCols}
                    showHeader={true}
                    showTable={true}
                    selectableRows={true}
                    multipleSelection={true}
                    deletableRows={true}
                    enableFilters={true}
                />
            </div>
        </div>
    );
};

export default UserGroups;